import React, { useState } from "react";

import abb from "../assets/brands/abb.png";
import siemens from "../assets/brands/Siemens.png";
import schneider from "../assets/brands/Schneider.png";
import lnt from "../assets/brands/lnt.png";
import allen from "../assets/brands/allen-bradley.png";
import omron from "../assets/brands/omron.png";
import havells from "../assets/brands/havells.png";

import danfoss from "../assets/brands/danfoss.png";
import delta from "../assets/brands/delta.png";
import yaskawa from "../assets/brands/yaskawa.png";
import cs from "../assets/brands/cs-electric.png";
import elmex from "../assets/brands/elemex.png";

import polycab from "../assets/brands/polycab.jpg";
import kei from "../assets/brands/kei.png";
import finolex from "../assets/brands/finolex.png";
import rr from "../assets/brands/rr-kabel.jpg";

import honeywell from "../assets/brands/honeywell.png";
import bosch from "../assets/brands/bosch.png";
import notifier from "../assets/brands/notifier.png";
import agni from "../assets/brands/agni.png";
import ravel from "../assets/brands/ravel.jpg";

import secure from "../assets/brands/secure.webp";
import socomec from "../assets/brands/socomec.png";
import rishabh from "../assets/brands/rishabh.png";
import yokogawa from "../assets/brands/yokogawa.png";

import apc from "../assets/brands/apc.png";
import numeric from "../assets/brands/numeric.png";
import microtek from "../assets/brands/microtek.png";
import vertiv from "../assets/brands/vertiv.png";

const SupplyRange = () => {

const [active, setActive] = useState("switchgear");
const [open, setOpen] = useState(null);

const toggle = (section) => {
setOpen(open === section ? null : section);
};

const categories = {

switchgear:{
title:"Switchgear",
products:[
"Air Circuit Breakers (ACB)",
"Vacuum Circuit Breakers (VCB)",
"Minimum Oil Circuit Breakers (MOCB)",
"SF6 Circuit Breakers",
"MCCB / MCB",
"ELCB / RCCB",
"Changeover Switches",
"Isolators & LBS",
"HRC Fuses"
],
brands:[
{name:"ABB",logo:abb},
{name:"Siemens",logo:siemens},
{name:"Schneider",logo:schneider},
{name:"L&T",logo:lnt}
]
},

automation:{
title:"Automation",
products:[
"Contactors",
"Control Relays",
"Time Delay Relays",
"Protection Relays",
"Overload Relays",
"PLC Modules",
"SMPS Power Supplies",
"Interface Relays",
"Push Buttons & Selector Switches",
"Proximity Sensors"
],
brands:[
{name:"ABB",logo:abb},
{name:"Siemens",logo:siemens},
{name:"Schneider",logo:schneider},
{name:"Allen-Bradley",logo:allen},
{name:"Omron",logo:omron}
]
},

drives:{
title:"Drives",
products:[
"Variable Frequency Drives",
"Soft Starters",
"VFD Keypads",
"Power Cards",
"IGBT Modules",
"Cooling Fans"
],
brands:[
{name:"ABB",logo:abb},
{name:"Siemens",logo:siemens},
{name:"Danfoss",logo:danfoss},
{name:"Delta",logo:delta},
{name:"Yaskawa",logo:yaskawa}
]
},

panel:{
title:"Panel Accessories",
products:[
"Copper & Aluminium Busbars",
"Busbar Supports",
"Heat Shrink Sleeves",
"Panel Cooling Fans",
"Space Heaters",
"Cable Ducts",
"Glands & Lugs"
],
brands:[
{name:"L&T",logo:lnt},
{name:"ABB",logo:abb},
{name:"Schneider",logo:schneider},
{name:"C&S Electric",logo:cs},
{name:"Elmex",logo:elmex}
]
},

cables:{
title:"Cables",
products:[
"HT & LT Power Cables",
"Control Cables",
"Cable Trays",
"Earthing Electrodes",
"Earthing Strips",
"Lightning Arresters"
],
brands:[
{name:"Polycab",logo:polycab},
{name:"KEI",logo:kei},
{name:"Finolex",logo:finolex},
{name:"RR Kabel",logo:rr},
{name:"Havells",logo:havells}
]
},

fire:{
title:"Fire Safety",
products:[
"Fire Alarm Panels",
"Smoke Detectors",
"Heat Detectors",
"Manual Call Points",
"Hooters",
"Emergency Lighting"
],
brands:[
{name:"Honeywell",logo:honeywell},
{name:"Bosch",logo:bosch},
{name:"Notifier",logo:notifier},
{name:"Agni",logo:agni},
{name:"Ravel",logo:ravel}
]
},

metering:{
title:"Metering",
products:[
"Energy Meters",
"Multifunction Meters",
"Current Transformers",
"Potential Transformers",
"Power Factor Controllers",
"Temperature Controllers"
],
brands:[
{name:"ABB",logo:abb},
{name:"Siemens",logo:siemens},
{name:"Schneider",logo:schneider},
{name:"Secure",logo:secure},
{name:"Socomec",logo:socomec},
{name:"Rishabh",logo:rishabh},
{name:"Yokogawa",logo:yokogawa}
]
},

ups:{
title:"UPS",
products:[
"UPS Systems",
"UPS Batteries",
"Servo Stabilizers",
"Capacitor Banks",
"APFC Panels"
],
brands:[
{name:"APC",logo:apc},
{name:"Numeric",logo:numeric},
{name:"Vertiv",logo:vertiv},
{name:"Delta",logo:delta},
{name:"Microtek",logo:microtek}
]
}

};

const data = categories[active];

return (

<section className="supply-section">

<style jsx="true">{`

.supply-section{
padding:70px 20px;
background:#f8f9fa;
}

.container{
max-width:1100px;
margin:auto;
}

.title{
text-align:center;
font-size:32px;
font-weight:700;
margin-bottom:10px;
}

.tabs{
display:flex;
flex-wrap:wrap;
gap:10px;
justify-content:center;
margin:30px 0;
}

.tab{
padding:10px 18px;
border-radius:25px;
border:1px solid #ddd;
cursor:pointer;
background:#fff;
}

.tab.active{
background:#d32f2f;
color:#fff;
border-color:#d32f2f;
}

.products{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(240px,1fr));
gap:12px;
margin-bottom:30px;
}

.product{
  background:#ffffff;
  padding:14px 18px;
  border-radius:10px;
  border:1px solid #e5e7eb;
  font-size:14px;
  display:flex;
  align-items:center;
  gap:8px;
  transition:all .25s ease;
  box-shadow:0 2px 4px rgba(0,0,0,0.03);
}

.product:hover{
  border-color:#d32f2f;
  transform:translateY(-2px);
  box-shadow:0 6px 16px rgba(0,0,0,0.08);
}

.product:before{
  content:"";
  width:6px;
  height:6px;
  border-radius:50%;
  background:#d32f2f;
}

.brand-grid{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(120px,1fr));
gap:20px;
}
.supply-eyebrow{
  text-align:center;
  font-size:12px;
  letter-spacing:2px;
  font-weight:700;
  color:#d32f2f;
  margin-bottom:10px;
  text-transform:uppercase;
}.title{
  text-align:center;
  font-size:32px;
  font-weight:700;
  margin-bottom:12px;
  color:#1e293b;
}

.title::after{
  content:"";
  display:block;
  width:60px;
  height:3px;
  background:#d32f2f;
  margin:10px auto 0;
}

.brand{
text-align:center;
}

.brand img{
height:40px;
object-fit:contain;
filter:grayscale(50%);
transition:.3s;
}

.brand img:hover{
filter:grayscale(0);
transform:scale(1.05);
}

.brand-name{
font-size:12px;
margin-top:5px;
}

.accordion{
margin-top:40px;
}

.acc-item{
background:#fff;
border-radius:6px;
margin-bottom:10px;
border:1px solid #eee;
}

.acc-header{
padding:15px;
cursor:pointer;
font-weight:600;
display:flex;
justify-content:space-between;
}

.acc-body{
padding:15px;
border-top:1px solid #eee;
}

@media(max-width:768px){

.tabs{
overflow-x:auto;
flex-wrap:nowrap;
}

.brand-grid{
grid-template-columns:repeat(2,1fr);
}

}

`}</style>

<div className="container">

<div className="supply-eyebrow">OUR SUPPLY RANGE</div>

<div className="title">Supply Range</div>


<div className="tabs">
{Object.keys(categories).map((key)=>(
<div
key={key}
className={`tab ${active===key?"active":""}`}
onClick={()=>setActive(key)}
>
{categories[key].title}
</div>
))}
</div>

<div className="products">
{data.products.map((p,i)=>(
<div key={i} className="product">{p}</div>
))}
</div>

<div className="brand-grid">
{data.brands.map((b,i)=>(
<div key={i} className="brand">
<img src={b.logo} alt={b.name}/>
<div className="brand-name">{b.name}</div>
</div>
))}
</div>

<div className="accordion">

<div className="acc-item">
<div className="acc-header" onClick={()=>toggle("generator")}>
Generators {open==="generator"?"−":"+"}
</div>
{open==="generator" && (
<div className="acc-body">
<ul>
<li>Diesel Generators</li>
<li>Silent Generator Sets</li>
<li>Standby Generators</li>
<li>Synchronizing Systems</li>
<li>DG Control Panels</li>
<li>AVR Modules</li>
<li>Alternator Spares</li>
</ul>
</div>
)}
</div>

<div className="acc-item">
<div className="acc-header" onClick={()=>toggle("transformer")}>
Transformers {open==="transformer"?"−":"+"}
</div>
{open==="transformer" && (
<div className="acc-body">
<ul>
<li>Power Transformers</li>
<li>Distribution Transformers</li>
<li>Dry Type Transformers</li>
<li>Oil Cooled Transformers</li>
<li>Isolation Transformers</li>
<li>Buchholz Relays</li>
<li>Breathers</li>
<li>Transformer Oil</li>
</ul>
</div>
)}
</div>

</div>

</div>

</section>
);
};

export default SupplyRange;